module.exports = __webpack_public_path__ + "img/brand (7).ba6f8527.svg";